export enum ProductTypes{
    // Summary:
        // The ag safe plus
        AGInvestPlus = 0,
        // Summary:
        // The ag fund stability
        AGFundStability = 1,
        // Summary:
        //  The ag fund neutral
        AGFundNeutral = 2,
        // Summary:
        // The ag fund dynamic
        AGFundDynamic = 3,
        // Summary:
        // The uppie moon
        UppieMoon = 4,
        // Summary:
        // The uppie star go
        UppieStarGo = 5,
        // Summary:
        // The uppie star run
        UppieStarRun = 6,
        // Summary:
        // The uppie star fly
        UppieStarFly = 7,
        //
        // Summary:
        // The Yongo Moon
        YongoMoon = 8,
        //
        // Summary:
        // The Yongo Star
        YongoStar = 9

}
